import SignatureVerificationFileDrop from '@/components/DigitalSignatureVerification';
import * as React from 'react';
export default {
  SignatureVerificationFileDrop,
  React
};